import { Button, SxProps, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import LoaderComp from "../../Loader/LoaderComp";
import { KeyDriveButtonDefaultStyles, KeyDriveButtonDefaultStylesWithoutBackground } from "./styles";
import { KeyDriveButtonStyles, KeyDriveButtonType } from "./types";

interface IKeyDriveButton {
    buttonContent: React.ReactNode;
    onClick?: React.MouseEventHandler<HTMLElement> | undefined;
    KeyDriveButtonStyle: KeyDriveButtonStyles;
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
    disabled?: boolean;
    KeyDriveButtonType: KeyDriveButtonType;
    loader?: boolean;
}

export const KeyDriveButton: React.FC<IKeyDriveButton> = ({
    KeyDriveButtonStyle,
    buttonContent,
    onClick,
    endIcon,
    startIcon,
    disabled,
    KeyDriveButtonType,
    loader
}) => {

    const [keyDriveButtonStyles, setKeyDriveButtonStyles] = useState<SxProps>(KeyDriveButtonDefaultStyles);

    useEffect(() => {
        if (KeyDriveButtonType == "secondary") {
            setKeyDriveButtonStyles(KeyDriveButtonDefaultStylesWithoutBackground);
        }
    }, [KeyDriveButtonType])

    useEffect(() => {

    }, [KeyDriveButtonStyle])

    return (
        <Button
            onClick={onClick}
            sx={keyDriveButtonStyles}
            variant={KeyDriveButtonType == "primary" ? "contained" : "outlined"}
            startIcon={startIcon}
            endIcon={endIcon}
            disabled={disabled}
        >
            <Typography
                textTransform="none"
            >
                { loader ? <LoaderComp /> : buttonContent }
            </Typography>
        </Button>
    )
}